module.exports = __webpack_public_path__ + "img/home-icon-1.9a379f8d.png";